import type React from 'react'
import type { JSX } from 'react'

import { SeasonBlockSC } from './SeasonBlock.styled'

export interface ISeasonBlockProps {
  children?: React.ReactNode
  dataTestId?: string
}

export const SeasonBlock = ({
  children,
  dataTestId,
}: ISeasonBlockProps): JSX.Element => (
  <SeasonBlockSC data-testid={dataTestId}>{children}</SeasonBlockSC>
)

SeasonBlock.displayName = 'SeasonBlock'
